module.exports = __webpack_public_path__ + "static/media/ARI-CORsys St.4cb71dd5.jpg";